import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "reduce-fields"
    }}>{`Reduce Fields`}</h1>
    <p>{`When the form value changed, you can alter the fields accordingly using the reduceFields function that comes along with the parameters in the onChangeHandler of form,
where reduceField is a function that accepts a closure that map old fields into new fields`}</p>
    <h2 {...{
      "id": "example---copy-the-text-field-value-to-label"
    }}>{`Example - copy the text field value to label`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`() => {
  const [value, setValue] = useState({})
  const handleChange = (newValue, {reduceFields}) => {
    reduceFields((oldFields) => {
      if(newValue.copyField.length) {
        oldFields.copyField.label = newValue.copyField
      } else {
        oldFields.copyField.label = 'Input some value'
      }
      return oldFields
    })
    setValue(newValue)
  }
  const fields = useMemo(() => jsyaml.load(\`
  copyField:
    type: text
    label: Input some value
    helperText: this will copy the value to label
    placeholder: label value
  \`), [])
  return (
    <div>
      <BaseForm fields={fields} value={value} onChange={handleChange}/>
      value:
      <pre>{JSON.stringify(value, null, 2)}</pre>
    </div>
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      